'use client'

import { useEffect, useLayoutEffect, useState } from 'react'

// const initialState = () => {
//   const screenWidth = window.innerWidth;
//   if (screenWidth <= 576) {
//     return "mobile";
//   } else if (screenWidth <= 992) {
//     return "tablet";
//   } else {
//     return "desktop";
//   }
// };

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window
  return {
    width,
    height,
  }
}
const useScreenSize = () => {
  const [screen, setScreen] = useState<'desktop' | 'tablet' | 'mobile'>('desktop')
  useLayoutEffect(() => {
    if (typeof window !== 'undefined') {
      const screenWidth = window.innerWidth
      if (screenWidth <= 576) {
        setScreen('mobile')
      } else if (screenWidth <= 992) {
        setScreen('tablet')
      } else {
        setScreen('desktop')
      }
    }
  }, [])
  useLayoutEffect(() => {
    const handleResize = (e: UIEvent) => {
      // Your logic to handle the screen size change
      const screenWidth = window.innerWidth
      if (screenWidth <= 576) {
        setScreen('mobile')
      } else if (screenWidth <= 992) {
        setScreen('tablet')
      } else {
        setScreen('desktop')
      }
    }

    // Add event listener on component mount
    window.addEventListener('resize', handleResize)

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return screen
}
export default useScreenSize
